<template>
  <h2>Dashboard</h2>
</template>

<script>
export default {
  mounted() {
    this.$store.commit("setPageTitle", "Dashboard");
  },
};
</script>

<style>
</style>